import React, { useEffect } from 'react';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { useModal } from 'src/state/modal';
import { config } from '@uhg-abyss/web/tools/config/config';
import { Text } from '@uhg-abyss/web/ui/Text';
import { event } from '@uhg-abyss/web/tools/event';
import PropTypes from 'prop-types';
import {
  ModalTitle,
  PaddedTitleBox,
  BodyContainer,
  StyledLayout,
} from './PermissionsModalComponents';

export const UserAccessErrorModal = ({ title, message, code }) => {
  const { modals } = useModal.state();
  const { toggleModal } = useModal.actions();

  const handleClose = () => {
    event('MODAL_CLOSE', { modalName: `${title} modal` });
    toggleModal({ key: 'permissions', isOpen: false });
  };

  const buttonHref =
    code === 'DSA:V:USR:NU'
      ? config('REGISTRATION_PAGE_URL')
      : '#/prefcenter/orgtaxIdAccess';

  const buttonText =
    code === 'DSA:V:USR:NU'
      ? 'Register your TIN'
      : 'Organization & Tax ID Access';

  const handleButtonClick = () => {
    if (code === 'DSA:V:USR:NU') {
      window.open(config('REGISTRATION_PAGE_URL'));
      event('EXIT_LINK_NAVIGATE', {
        linkText: buttonText,
        linkUrl: buttonHref,
      });
    } else {
      window.location.href = '#/prefcenter/orgtaxIdAccess';
    }
    event('OOPS_MODAL_LINK_CLICK', {
      interactionName: title,
      interactionValue: buttonText,
      interactionContext: `${title} modal`,
    });
    toggleModal({ key: 'permissions', isOpen: false });
    event('MODAL_CLOSE', { modalName: `${title} modal` });
  };

  useEffect(() => {
    if (modals.permissions) {
      event('MODAL_OPEN', { modalName: `${title} modal` });
    }
  }, [modals.permissions]);

  return (
    <Modal
      id="new-user-tin-access-modal"
      data-testid="new-user-tin-access-modal"
      model="customization"
      isOpen={modals.permissions}
      onClose={handleClose}
    >
      <Modal.Section>
        <PaddedTitleBox color="white">
          <Layout.Stack alignLayout="center" space={16}>
            <IconBrand icon="alert" size="xl" />
            <ModalTitle offset={2}>{title}</ModalTitle>
          </Layout.Stack>
        </PaddedTitleBox>
        <BodyContainer textalign="center">
          <StyledLayout alignLayout="center" alignItems="center" space={20}>
            <Text>{message}</Text>

            <Button
              size="$lg"
              id="user-error-permissions-oops-modal"
              data-testid="user-error-permissions-modal"
              aria-label={buttonText}
              onClick={handleButtonClick}
            >
              {buttonText}
            </Button>
          </StyledLayout>
        </BodyContainer>
      </Modal.Section>
    </Modal>
  );
};

UserAccessErrorModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  code: PropTypes.string,
};

UserAccessErrorModal.defaultProps = {
  title: '',
  message: '',
  code: '',
};
